module.exports = __webpack_public_path__ + "img/xinyonghu_hebing_00000.73ea68f8.jpg";